import { Nullable } from "../../base-types";
import { ITERATING } from "../../constants/defaults";
import { IQueryResult } from "./query-result";

export class QueryResultPagingManager {
    static canMovePrevious(queryResult: Nullable<IQueryResult>): boolean {
        return !!queryResult && queryResult.offset > 0;
    }
    static canMoveNext(queryResult: Nullable<IQueryResult>): boolean {
        return (
            !queryResult || QueryResultPagingManager.getOffsetNextPage(queryResult) < queryResult.totalNumberOfResults
        );
    }
    static getOffsetPreviousPage(queryResult: Nullable<IQueryResult>): number {
        return Math.max(queryResult != null ? queryResult.offset - queryResult.items.length : 0, 0);
    }
    static getOffsetNextPage(queryResult: Nullable<IQueryResult>): number {
        return Math.max(queryResult != null ? queryResult.offset + queryResult.items.length : 0, 0);
    }
    static getIterationPageSize(queryResult: Nullable<IQueryResult>): number {
        return !queryResult || queryResult.items.length === 0 ? ITERATING.pageSize : queryResult.items.length;
    }
}
